import React from 'react';
import cn from 'classnames';

interface Header {
  children: React.ReactNode;
  color?: 'dark' | 'white';
  style?: React.CSSProperties;
}

const Header = {
  H2: ({ children, color, style }: Header) => (
    <h2
      className={cn('whatcrm-widget-header whatcrm-widget-header_h2', {
        [`whatcrm-widget-header_${color}`]: color,
      })}
      style={style}
    >
      {children}
    </h2>
  ),
  H3: ({ children, color, style }: Header) => (
    <h3
      className={cn('whatcrm-widget-header whatcrm-widget-header_h3', {
        [`whatcrm-widget-header_${color}`]: color,
      })}
      style={style}
    >
      {children}
    </h3>
  ),
};

export default Header;
